module.exports = __webpack_public_path__ + "static/media/proposal_verification_audio.765c6bf2.mp3";